/* eslint-disable max-lines-per-function */
import { Body, Progress } from '@e2n/ui/v2';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { faGraduationCap, faStar } from '@fortawesome/pro-regular-svg-icons';
import {
  faStar as faStarFilled,
  faStarHalfStroke,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function RotationsplanProgress({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const { t } = useTranslation();
  const percentage =
    (rotationsplan.abgeschlosseneStationen.length * 100) /
    rotationsplan.amountOfStationen;

  const alleStationen = rotationsplan.allStationen;

  const firstStation = alleStationen[0];
  const lastStation = alleStationen[alleStationen.length - 1];
  const bewertungCount = rotationsplan.bewertungenMitSternen.length;
  const averageBewertungScore = rotationsplan.getAverageBewertungScore();

  return (
    <div className="flex sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-4 flex-col items-start">
      <div className="flex items-center gap-2 w-full md:w-1/2">
        <Progress
          value={percentage}
          showText={false}
          className="w-34 shrink-0 md:w-full md:shrink"
        />
        <Body className="hidden md:flex whitespace-nowrap">
          {alleStationen.length > 0
            ? t('domain.mitarbeiter.rotationsplan.rotationsplaene.progress', {
                abgeschlossen: rotationsplan.abgeschlosseneStationen.length,
                alleStationen: alleStationen.length,
              })
            : t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.keineStationen',
              )}
        </Body>
        <Body className="flex md:hidden whitespace-nowrap">
          {alleStationen.length > 0
            ? `${rotationsplan.abgeschlosseneStationen.length} / ${rotationsplan.amountOfStationen}`
            : t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.keineStationen',
              )}
        </Body>
      </div>
      {alleStationen.length > 0 && (
        <div className="flex items-center gap-4 whitespace-nowrap">
          {bewertungCount > 0 && (
            <div className="flex items-center gap-1">
              <Body>
                {averageBewertungScore.toLocaleString('de-DE', {
                  maximumFractionDigits: 1,
                })}
              </Body>
              <div className="flex items-center gap-0.5 text-labels-primary">
                {[1, 2, 3, 4, 5].map((value) => (
                  <FontAwesomeIcon
                    key={value}
                    className="size-4.5"
                    icon={
                      averageBewertungScore >= value
                        ? faStarFilled
                        : averageBewertungScore >= value - 0.5
                          ? faStarHalfStroke
                          : faStar
                    }
                  />
                ))}
              </div>
              <Body>({bewertungCount})</Body>
            </div>
          )}
          <div className="flex items-center gap-1">
            <FontAwesomeIcon
              className="size-5.5 text-labels-primary"
              icon={faGraduationCap}
            />
            <Body>
              {`${dayjs(firstStation.von).format('MMM YYYY')} – ${dayjs(lastStation.bis).format('MMM YYYY')}`}
            </Body>
          </div>
        </div>
      )}
    </div>
  );
}
